import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "button-default__spinner"
}

import {computed} from "vue";

interface Props {
    outline?:           boolean,
    flat?:              boolean,
    opacityButton?:     boolean,
    disable?:           boolean,
    loading?:           boolean,
    label?:             string | null,
    color?:             string | null,
    bgColor?:           string | null,
    borderColor?:       string | null,
}

interface Styles {
    color:           string | undefined,
    background:      string | undefined,
    borderColor:     string | undefined,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonDefault',
  props: {
    outline: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    opacityButton: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    label: { default: null },
    color: { default: null },
    bgColor: { default: null },
    borderColor: { default: null }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const computedClass = computed(() => {
    const classes = [];
    
    if (props.outline) {
        classes.push('outline')
    }
    
    if (props.flat) {
        classes.push('flat')
    }
    
    if (props.opacityButton) {
        classes.push('opacity-button')
    }
    
    if (props.disable || props.loading) {
        classes.push('custom-disable')
    }
    
    if (props.loading) {
        classes.push('loading')
    }
    
    return classes
})

const computedStyle = computed(() => {
    const styles = <Styles>{};
    
    if (props.color) {
        styles.color = props.color;
    }
    
    if (props.bgColor) {
        styles.background = props.bgColor;
        
        if (props.borderColor) {
            styles.borderColor = props.borderColor;
        }
        else if (props.bgColor.startsWith('#')) {
            styles.borderColor = props.bgColor;
        }
    }
    
    return styles;
})

function handleClick(event: any) {
    if (props.loading || props.disable) {
        event.stopPropagation();
        event.preventDefault();
        return;
    }
    
    emit('click')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button-default", [computedClass.value]]),
    style: _normalizeStyle({...computedStyle.value}),
    onClick: handleClick
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["d-flex justify-center items-center", [_ctx.loading ? 'opacity-0' : '']])
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 6))
}
}

})